export default function TypeaheadBaseController(
    $scope,
    trainsApiService
) {
    'ngInject';

    $scope.airports = [];

    $scope.getLocation = function(searchString) {

        $scope.airports = [];

        if (searchString && searchString.length < 2) {
            return $scope.airports;
        }

        const requestData = {
            params: {searchPattern: searchString},
            noSpinner: true,
        };

        return trainsApiService.searchLocation(requestData);
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/trains-base/controllers/trains-typeahead-base-controller.js